const myregexp =
  /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?|live)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/gi;

export const parseYoutubeId = (url: string): string | undefined => {
  return myregexp.exec(url)?.[1];
};

export const getImageUrl = (id: string) =>
  `https://img.youtube.com/vi/${id}/mqdefault.jpg`;

export const getPlaybackUrl = (id: string, timestampMillis?: number) => {
  let url = `https://www.youtube.com/watch?v=${id}`;
  if (timestampMillis) {
    const seconds = Math.floor(timestampMillis / 1000);
    url += `&t=${seconds}s`;
  }
  return url;
};
